export default {
  methods: {
    getAlertColor(mins) {
      if (mins >= 90) return "red";
      return "black";
    },
    getAlertIcon(mins) {
      if (mins >= 120) return "error";
      return "error_outline";
    },
    getAlertSize(mins) {
      if (mins >= 120) return "25px";
      if (mins >= 90) return "22px";
      return "18px";
    },
    getMinsBold(mins) {
      if (mins >= 30) return "900";
    },
    getMinsFontSize(mins) {
      if (mins >= 30) return "15px";
    }
  }
};
